import SliderImage from "../../components/SliderImage";
import Notification from "./Notification";
import SideBar from "../../layouts/SideBar";
import { useEffect } from "react";
import ContactFaculty from "../../components/ContactFaculty";
import ComputerRoom from "../ComputerRoom";
const list_notification = [
    'Thông báo về việc đăng ký môn học học kỳ II, năm học 2023-2024',
    'Thông báo về việc đăng kí môn học bổ sung học kỳ phụ năm học 2022-2023',
    'Lịch thi của SV không chọn hình thức thi trực tuyến học kì 2 năm học 2020-2021',
    'Thông báo lịch thi của các sinh viên hoãn thi, xin thi lại học kì 1 năm học 2022-2023',
    'Lịch thi của SV hoãn thi được thi lại (bổ sung) – HK2, năm học 2021-2022'
]
export default function Home() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <div className="home-page">
            <SliderImage />
            <div className="home-page-main">
                <div className="home-page-content">
                    <div className="home-page--top">
                        <div className="home-page--notification w-4/6">
                            <Notification />
                            <div className="home-page-list-notification">
                                {list_notification.map((item) => {
                                    return (
                                        <div className="list-notification--item">{`❖ ${item}`}</div>
                                    )
                                })}
                            </div>
                        </div>
                        <SideBar />
                    </div>
                    <div className="home-page--bottom">
                        <div className="home-title w-4/6"> Lịch phòng máy</div>
                        <ComputerRoom />
                    </div>
                    <div className="home-page--bottom">
                        <div className="home-title w-4/6"> Thông tin các khoa</div>
                        <ContactFaculty />
                    </div>
                </div>
            </div>
        </div>
    )
}